function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-disable no-unused-vars */
import { stokpress, stokpressViewPort } from '../util/helper';
import { productView } from "../components/analytics-ca";
import flexibleVideo from './flexible-video';
/* eslint-disable no-undef */

var Product = {};
var productMetaContainer = document.getElementById('js-product-meta'),
  productInfoContainer = document.getElementById('js-selected-product-info'),
  productSectionsContainer = document.getElementById('js-selected-product-sections'),
  productColorsContainer = document.getElementById('js-product-select-color'),
  productSwatchSelector = 'js-swatch-selector',
  productSizeSelector = 'js-change-select-size',
  productColorSlider = productColorsContainer ? productColorsContainer.querySelector('.js-systemparts-slider') : null,
  defaultIndex = productColorSlider ? productColorSlider.dataset.index : 0,
  ajaxRequestEnable = true;
Product.setDefaultMobileSelectedSize = function (wrapper) {
  var isMobile = stokpress.isMobile() || stokpressViewPort.documentWidth().width < 991;
  if (!wrapper || !isMobile) {
    return;
  }
  var inStock = wrapper.querySelector("option:not([disabled])");
  var sizeOptions = wrapper.querySelectorAll("option");

  // remove initially selected option
  if (sizeOptions.length) {
    Array.prototype.forEach.call(sizeOptions, function (size) {
      size.removeAttribute('selected');
    });
  }
  if (inStock) {
    wrapper.value = inStock.value;
    inStock.setAttribute('selected', 'selected');
    Product.selectSizeInput(wrapper, inStock.value);
  }
};
Product.changeSelectSize = function () {
  var callEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var sizes = document.getElementsByClassName(productSizeSelector);
  if (sizes.length === 0) return;
  Array.prototype.forEach.call(sizes, function (size) {
    var wrapper = stokpress.findAncestor(size, 'js-form-wrapper');
    Product.setDefaultMobileSelectedSize(wrapper);
    if (callEvent) Product.changeSelectSizeEvent(wrapper, size);
  });
};
Product.changeSelectSizeEvent = function (wrapper, size) {
  if (!wrapper || !size) return;
  size.addEventListener('change', function (event) {
    wrapper = stokpress.findAncestor(this, 'js-form-wrapper');
    var select_value = this.value;
    Product.selectSizeInput(wrapper, select_value);
  });
};
Product.selectSizeInput = function (wrapper, select_value) {
  if (!wrapper || !select_value) return;
  var inputs = wrapper.querySelectorAll('input[name="esc_product_item"]');
  if (inputs.length) {
    Array.prototype.forEach.call(inputs, function (input) {
      if (input.value === select_value) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    });
  }
};
Product.processChangeColor = function (el) {
  var url = Product.ajaxUrl + el.dataset.id;
  if (Product.currentLang) {
    url = url + '?lang=' + Product.currentLang;
  }
  if (productColorsContainer && productColorsContainer.dataset.id !== el.dataset.id) {
    Product.processRequest('GET', url, el.dataset.url);
  }
};
Product.changeSwatch = function (swatches) {
  if (!swatches) {
    return;
  }
  Array.prototype.forEach.call(swatches, function (swatch) {
    swatch.addEventListener('click', function (event) {
      event.preventDefault();
      // Product.processChangeColor( this );
      var targetEl = document.querySelector('.js-color-trigger[data-id="' + this.dataset.id + '"]');
      if (targetEl) {
        targetEl.click();
      }
    });
  });
};
Product.changeColor = function (colors) {
  if (!colors) {
    return;
  }
  Array.prototype.forEach.call(colors, function (color) {
    color.addEventListener('click', function (event) {
      event.preventDefault();
      Product.processChangeColor(this);
    });
  });
};
Product.processRequest = function (action, url, targetUrl) {
  // To avoid double send of ajax request
  if (!ajaxRequestEnable) {
    return;
  }
  var xhr = new XMLHttpRequest();
  ajaxRequestEnable = false;
  Product.disableColor(true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4) {
      return;
    }
    if (xhr.status === 200) {
      try {
        var data = JSON.parse(xhr.response);
        Product.outputResult(data, targetUrl);
        ajaxRequestEnable = true;
        Product.disableColor(false);
      } catch (err) {
        console.log(err);
      }
    }
  };
  xhr.open(action, url, true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send();
};
Product.disableColor = function (isDisable) {
  // Flickity button
  var controls = productColorSlider.querySelectorAll('button');
  if (controls) {
    Array.prototype.forEach.call(controls, function (el) {
      if (isDisable) {
        el.setAttribute('disabled', '');
      } else if (el.hasAttribute('disabled')) {
        el.removeAttribute('disabled');
      }
    });
  }

  // Loader
  var loader = productColorsContainer.querySelector('.js-slider-loader');
  if (loader) {
    if (isDisable) {
      loader.classList.remove('d-none');
    } else {
      loader.classList.add('d-none');
    }
  }
};
Product.outputResult = function (data, targetUrl) {
  if (!data.product) {
    return;
  }
  window.history.pushState(data, '', targetUrl);
  Product.updateHtml(data);
};
Product.updateHtml = function (data) {
  productMetaContainer.innerHTML = data.product.meta;
  productInfoContainer.innerHTML = data.product.info;
  productSectionsContainer.innerHTML = data.product.sections;
  productColorsContainer.dataset.id = data.product.current_color.postId;
  var colorTitle = productColorsContainer.querySelector('.js-color-title');
  if (colorTitle) {
    colorTitle.innerHTML = data.product.current_color.header.title;
  }
  var colorPreamble = productColorsContainer.querySelector('.js-color-preamble');
  if (colorPreamble) {
    colorPreamble.innerHTML = data.product.current_color.header.preamble;
  }
  var colorSlider = productColorsContainer.querySelector('.js-systemparts-slider');
  if (colorSlider) {
    var colorIndex = _typeof(data.product.current_color.index) === undefined ? defaultIndex : data.product.current_color.index;
    colorSlider.dataset.index = colorIndex;
  }

  // SOS update color on title tag when swatch is changed.
  var currentColorVariantEl = productMetaContainer.querySelector('.variant');
  var currentColorVariant = currentColorVariantEl.dataset ? currentColorVariantEl.dataset.variant : '';
  if (currentColorVariant) {
    Product.updateMetaTags(currentColorVariant);
  }
  // EOS update color on title tag when swatch is changed.

  Product.init(true);
  flexibleVideo();
};
Product.updateMetaTags = function (currentColor) {
  if (!currentColor) return;
  var metas = ['title', 'meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:description"]', 'meta[property="twitter:title"]'];
  Array.prototype.forEach.call(metas, function (selector) {
    var metaCollection = document.querySelector(selector);
    if (metaCollection) {
      var metaContent = selector === 'title' ? metaCollection.innerHTML : metaCollection.getAttribute('content');
      var swatches = document.getElementsByClassName(productSwatchSelector);
      if (swatches.length) {
        Array.prototype.forEach.call(swatches, function (swatch) {
          var swatchColor = swatch.dataset.color;
          if (swatchColor) {
            metaContent = metaContent.replace(new RegExp('\\b' + swatchColor + '\\b'), currentColor);
          }
        });
      }
      if (selector === 'title') {
        metaCollection.innerHTML = metaContent.replace('  ', ' ');
      } else {
        metaCollection.setAttribute('content', metaContent.replace('  ', ' '));
      }
    }
  });
};
Product.init = function (reinit) {
  if (!productMetaContainer || !productInfoContainer || !productSectionsContainer || !productColorsContainer) {
    return;
  }
  Product.ajaxUrl = productMetaContainer.dataset.url;
  Product.currentLang = productMetaContainer.dataset.lang;
  Product.changeSwatch(document.getElementsByClassName(productSwatchSelector));
  Product.changeSelectSize();
  if (reinit) {
    window.StellarAccordion.init();
    window.lazyLoadInstance.update();
    window.SystemSlider.slider();
    window.SelectedModal.init();
    window.CompareProduct.slider();
    window.ProductSelectedSlider.slider();
    window.PromoSlider.slider();
    window.Video.init();
    window.Usp.init();
    window.Newsletter.init('.js-newsletter', '#js-newsletter-modal');
    window.ImageSwitch.init();
    window.stickyCart.init();
    productView($('section.js-product-info').data('product') || '');
  } else {
    Product.changeColor(productColorsContainer.querySelectorAll('.js-product-colors'));
  }
};
document.addEventListener('DOMContentLoaded', function () {
  Product.init(false);
  if (typeof history.pushState !== 'undefined') {
    if (Product.productColors) {
      var initialColorData = {};
      initialColorData.product = {};
      initialColorData.product.meta = productMetaContainer.innerHTML;
      initialColorData.product.info = productInfoContainer.innerHTML;
      initialColorData.product.sections = productSectionsContainer.innerHTML;
      var current_color = {};
      current_color.header = {
        title: productColorsContainer.querySelector('.js-color-title'),
        preamble: productColorsContainer.querySelector('.js-color-preamble')
      };
      current_color.id = '';
      current_color.index = '';
      current_color.postId = productColorsContainer.dataset.id;
      window.history.replaceState(initialColorData, '', location.pathname);
    }
    window.addEventListener('popstate', function (e) {
      var data = e.state;
      if (data && _typeof(data) === 'object') {
        Product.disableColor(true);
        setTimeout(function () {
          Product.updateHtml(data);
          Product.disableColor(false);
          window.SystemSliderPart.slider();
        }, 500);
      } else {
        // Product not loaded
      }
    });
  }
});
window.addEventListener('resize', function () {
  Product.changeSelectSize(false);
});
window.Product = Product;


// WEBPACK FOOTER //
// ./scripts/components/product.js